export const SEARCH_OPTIONS = {
  keys: [
    { name: 'id', weight: 1 },
    { name: 'contact_info.trading_name', weight: 1 },
    { name: 'contact_info.contact_name', weight: 1 },
    { name: 'contact_info.contact_email', weight: 1 },
  ],
  includeMatches: true,
  matchAllOnEmptyQuery: true,
  minMatchCharLength: 4,
  threshold: 0.2,
  distance: 1000,
  ignoreLocation: true,
};
